const UserSearchResultItemSkeleton = () => {
  return (
    <div className="flex flex-row items-center gap-3 py-2">
      <div className="flex flex-row items-center gap-2">
        <div className="size-[40px] animate-pulse rounded-full bg-gray-200" />
        <div className="flex flex-col gap-1">
          <div className="h-4 w-32 animate-pulse rounded bg-gray-200" />
          <div className="h-3 w-24 animate-pulse rounded bg-gray-200" />
        </div>
      </div>
    </div>
  )
}

export default UserSearchResultItemSkeleton
